import { useState, useRef, useEffect } from 'react';
import { useHistory } from "react-router";
import Sidebar from '../../../components/Navigation/Sidebar';
import Topbar from '../../../components/Navigation/Topbar';
import Header from '../../../components/Page/header';
import { ConvertToMoney } from '../../../utils/formattingUtils';
import { buttonIcon, buttonTypes } from "../../../utils/buttonsUtil";
import Grid from '../../../components/Grid';
import { connect } from "react-redux";
import { useAutomaticAssignmentSocket } from "../../../hooks/automaticAssignmentSocket";

const AssignedOrders = ({
    addressesToAutomaticAssingment,
    reduxGetAllAddressesToautomaticAssigment,
    reduxGetAllAddressesToautomaticAssigmentSocket,
    currentAddressThatHasBeenChangedSocket,
    reduxDownloadAllAutomaticAssigment,
    reduxResetAllAddressesToautomaticAssigment,
}) => {
    const history = useHistory();
    const searchRef = useRef("");
    const socketRef = useRef(null);

    const { subscribe } = useAutomaticAssignmentSocket();
    
    const [offset, setOffset] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [idState, setIdState] = useState(4);
    const [search, setSearch] = useState("");

    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    useEffect(() => {
        let filters = {
            from: formatDate(new Date()),
            to: formatDate(new Date()),
            page: currentPage,
            offset,
            search,
            idState
        };

        reduxGetAllAddressesToautomaticAssigment(filters);
    }, [currentPage, offset])

    useEffect(() => {
        const filters = {
            from: formatDate(new Date()),
            to: formatDate(new Date()),
            page: currentPage,
            offset,
            search,
            idState
        };
        reduxGetAllAddressesToautomaticAssigmentSocket(filters);

    }, [currentAddressThatHasBeenChangedSocket]);

    const actionButtons = [
        {
            onClick: () => history.push("/assigner"),
            description: "Ir al dashboard de asignador automático",
            buttonType: buttonTypes.Primary,
            buttonIcon: buttonIcon.Arrow_LeftReply,
        },
    ];

    const customStyles = {
        AssignedOrdersColorCard: {
            background: '#57C785',
            background: 'linear-gradient(90deg,rgba(87, 199, 133, 0.76) 58%, rgba(87, 199, 133, 1) 100%)',
        },
        greenButton: {
            backgroundColor: 'rgba(87, 199, 133, 1)',
            borderColor: 'rgba(87, 199, 133, 1)',
            color: '#fff'
        }
    };

    const columns = [
        {
            title: '#',
            render: (rowData) => {
                return <span>{rowData.idAddress}</span>;
            },
            field: 'idAddress',
            searchable: true,
        },
        {
            title: 'Guía',
            render: (rowData) => {
                return <span>{rowData.trackingId}</span>;
            },
            field: 'trackingId',
            searchable: true,
        },
        {
            title: 'Remitente',
            render: (rowData) => {
                return <span>{rowData.shipperName ? rowData.shipperName : ''}</span>;
            },
            field: 'company.description',
            searchable: true,
        },
        {
            title: 'Valor Declarado',
            render: (rowData) => {
                return <span>{ConvertToMoney(rowData.collection)}</span>;
            },
            field: 'collection',
        },
        {
            title: 'Dirección',
            render: (rowData) => {
                return <span>{rowData.address}</span>;
            },
        },
        {
            title: 'Ciudad destino',
            render: (rowData) => {
                return <span>{rowData.cityNameReceiver ? rowData.cityNameReceiver : ''}</span>;
            },
            field: 'city.description',
            searchable: true,
        },
        {
            title: 'ID Externo',
            render: (rowData) => {
                return <span>{rowData.externalId}</span>;
            },
            field: 'externalId',
            searchable: true,
        },
        {
            title: 'Operador',
            render: (rowData) => {
                return <span>{rowData.operatorName ? rowData.operatorName : ''}</span>;
            },
            field: 'operator',
            searchable: true,
        }
    ]

    return (
        <div id='wrapper'>
            <Sidebar />
            <div id='content-wrapper' className='d-flex flex-column'>
                <div id='content'>
                    <Topbar />
                    <div className="container-fluid">
                        <Header title={"Órdenes Asignadas"} actionButtons={actionButtons} />

                        <div className='card shadow mb-4'>
                            <div className='card-header py-3'>
                                <h6 className='m-0 font-weight-bold text-primary'>Listado de Órdenes</h6>
                            </div>

                            <div className='d-flex align-items-center justify-content-end mt-2 mr-4'>

                                <div className='card shadow mb-0' style={customStyles.AssignedOrdersColorCard}>
                                    <div className='mx-3 pt-1 pb-2'>
                                        <div className='row no-gutters align-items-center'>
                                            <div className='col mr-2'>
                                                <div className='text-xs font-weight-bold text-uppercase text-white'>
                                                    Órdenes asignadas hoy:
                                                </div>
                                            </div>
                                            <div className='h5 mb-0 font-weight-bold text-white'>
                                                {addressesToAutomaticAssingment && addressesToAutomaticAssingment.hasOwnProperty('total') ? addressesToAutomaticAssingment.total : 0}
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <button
                                    title='Descargar lista de órdenes asignadas'
                                    className='btn ml-1'
                                    type='button'
                                    style={customStyles.greenButton}
                                    onClick={() => reduxDownloadAllAutomaticAssigment({
                                        from: formatDate(new Date()),
                                        to: formatDate(new Date()),
                                        idState: 4, 
                                        search: searchRef.current 
                                    })}>
                                    <i className='fas fa-file-download fa-sm'></i>
                                </button>
                            </div>

                            <div className='card-body'>
                                <Grid
                                    className='stickyAddress'
                                    cols={columns}
                                    data={addressesToAutomaticAssingment && Object.keys(addressesToAutomaticAssingment).length > 0 ? addressesToAutomaticAssingment.items : []}
                                    total={addressesToAutomaticAssingment && addressesToAutomaticAssingment.hasOwnProperty('total') ? addressesToAutomaticAssingment.total : 0}
                                    page={addressesToAutomaticAssingment && Object.keys(addressesToAutomaticAssingment).length > 0 ? Number(addressesToAutomaticAssingment.page) : currentPage}
                                    pages={addressesToAutomaticAssingment && Object.keys(addressesToAutomaticAssingment).length > 0 ? Number(addressesToAutomaticAssingment.totalPages) : 0}
                                    offset={offset}
                                    onChangePage={(page) => setCurrentPage(page)}
                                    onChangeRange={(value) => {
                                        setOffset(value);
                                        setCurrentPage(1);
                                    }}
                                    onChangeSearch={(value) => {
                                        setSearch(value)
                                        searchRef.current = value;
                                        
                                        const filters = {
                                            page: currentPage,
                                            offset,
                                            search: value,
                                            idState,
                                            from: formatDate(new Date()),
                                            to: formatDate(new Date()),
                                        }

                                        reduxGetAllAddressesToautomaticAssigment(filters);
                                    }}
                                >
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        addressesToAutomaticAssingment: state.addressToAutomaticAssigmentState.addressesToAutomaticAssingment,
        currentAddressThatHasBeenChangedSocket: state.addressToAutomaticAssigmentState.currentAddressThatHasBeenChangedSocket,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        reduxGetAllAddressesToautomaticAssigment: (payload) =>
            dispatch({
                type: "GetAllAddressesToAutomaticAssigment",
                value: payload,
            }),
        reduxGetAllAddressesToautomaticAssigmentSocket: (payload) =>
            dispatch({
                type: "GetAllAddressesToAutomaticAssigmentSocket",
                value: payload,
            }),
        reduxDownloadAllAutomaticAssigment: (payload) =>
            dispatch({
                type: "DownloadAllAutomaticAssigment",
                value: payload,
            }),
        reduxResetAllAddressesToautomaticAssigment: () =>
            dispatch({ type: "RESET_ALL_ADDRESSES_TO_AUTOMATIC_ASSIGMENT" }),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AssignedOrders);